import React, { FC, useState } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { Button } from 'transfix-ui/components/Button'
import { InputMultiSelect } from 'transfix-ui/components/InputMultiSelect'
import { $enum } from 'ts-enum-util'
import { IRawFilters, TPartnerType } from 'apps/edi-tools/types'
import { TextInput } from 'components/atoms'
import { DatePicker } from 'components/forms'
import { ButtonGroup } from 'transfix-ui'

interface IProps {
  filters: IRawFilters
  applyFilters: Function
}

type FileTypes =
  | 'Functional Acknowledgement'
  | 'Invoice'
  | 'Status Message'
  | 'Tendered Load'
  | 'Tendered Load Response'
  | 'Application Advice'

export const EDI_FILE_TYPE_NAMES: Record<FileTypes, string> = {
  'Tendered Load': '204',
  'Functional Acknowledgement': '997',
  'Tendered Load Response': '990',
  'Status Message': '214',
  Invoice: '210',
  'Application Advice': '824',
}

export const Filters: FC<IProps> = ({ applyFilters, filters }) => {
  const [partnerType, setPartnerType] = useState<TPartnerType>(
    filters.carrierId ? 'carrier' : 'shipper'
  )

  const shipmentIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) =>
    applyFilters({ shipmentId: e.target.value })

  const partnerIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filterKey = `${partnerType}Id`
    applyFilters({ [filterKey]: e.target.value })
  }

  const partnerTypeChangeHandler = (value: string) => {
    setPartnerType(value as TPartnerType)
    applyFilters({ carrierId: '', shipperId: '' })
  }

  const ediFileTypeChangeHandler = (options: ISelectOption[]) =>
    applyFilters({ fileTypes: options.map(o => o.value) })

  const createdBeforeDateChangeHandler = (selectedDate: string[]) =>
    applyFilters({ createdBeforeDate: selectedDate[0] })

  const createdAfterDateChangeHandler = (selectedDate: string[]) =>
    applyFilters({ createdAfterDate: selectedDate[0] })

  return (
    <div>
      {/* TODO: add some spacing / adjust the filters layout */}
      <h3>Filter</h3>
      <hr />
      <TextInput
        clearable
        name='shipmentId'
        id='filterShipmentId'
        label='Shipment'
        className='mb2'
        value={filters.shipmentId}
        placeholder='Shipment ID'
        onChange={shipmentIdChangeHandler}
      />
      <ButtonGroup
        className='mb2'
        value={partnerType}
        hideLabel
        onChange={partnerTypeChangeHandler}
        dataTest='assign-driver'>
        <Button value='carrier'>Carrier</Button>
        <Button value='shipper'>Shipper</Button>
      </ButtonGroup>
      <TextInput
        clearable
        name='partnerId'
        value={partnerType === 'shipper' ? filters.shipperId : filters.carrierId}
        placeholder={`${partnerType.charAt(0).toUpperCase() + partnerType.slice(1)} ID`}
        onChange={partnerIdChangeHandler}
      />
      <span>EDI Message Type</span>
      <InputMultiSelect
        options={$enum(EDI_FILE_TYPE_NAMES).map((value, label) => ({ label, value }))}
        values={filters.fileTypes}
        onChange={ediFileTypeChangeHandler}
      />
      <span>Created before</span>
      <DatePicker
        onDateChange={createdBeforeDateChangeHandler}
        placeholder='Created before date'
        date={filters.createdBeforeDate}
      />
      <span>Created after</span>
      <DatePicker
        onDateChange={createdAfterDateChangeHandler}
        placeholder='Created after date'
        date={filters.createdAfterDate}
      />
    </div>
  )
}
